// extracted by mini-css-extract-plugin
module.exports = {"searchQuerySelectStack":"style_searchQuerySelectStack__DFvRb","searchQuerySelect":"style_searchQuerySelect__wt7S5"};